// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/_layout.tsx"); } },
  "./admin.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/admin.tsx"); } },
  "./auth/login.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/auth/login.tsx"); } },
  "./auth/return-to-merchant.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/auth/return-to-merchant.tsx"); } },
  "./configure-sub.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/configure-sub.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/index.tsx"); } },
  "./license.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/license.tsx"); } },
  "./privacy-policy.tsx": { enumerable: true, get() { return require("/opt/build/repo/src/app/privacy-policy.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;